module.exports = __webpack_public_path__ + "img/new_set_bj.772a4493.jpg";